import Base from './base'
import Segments from './segments'
import MCPOption from './multiple_choice_poll_option'

export default class SegmentingOption extends Base {
  initialize () {
    super.initialize(...arguments)

    this.set({
      segments: new Segments(this.get('options')),
      mcpOption: new MCPOption(this.get('this_option'))
    })

    this.get('segments').segmentingOption = this
  }

  parse (json, options) {
    if (json == null) { json = {} }
    if (!this.get('segments')) {
      this.set({ segments: new Segments() })
    }
    if (json.options) {
      this.get('segments').reset(json.options, options)
    }

    if (!this.get('mcpOption')) {
      this.set({ mcpOption: new MCPOption() })
    }
    if (json.this_option) {
      this.get('mcpOption').set(json.this_option, options)
    }

    /*
     * TODO: Uncomment this once the viz project doesn't reference this attribute directly.
     * delete json.options
     */

    return json
  }

  responseCount (opts) {
    if (opts == null) { opts = {} }
    if (opts.includeNonResponses == null) { opts.includeNonResponses = false }

    let count = this.get('total_results')
    if (!opts.includeNonResponses) { count -= this.get('no_responses') }

    return count
  }

  maxResponseCount (opts) {
    if (opts == null) { opts = {} }
    return this.collection.maxResponseCount(opts)
  }

  percentOfMaxResponseCount (opts) {
    if (opts == null) { opts = {} }
    return this.responseCount(opts) / this.maxResponseCount(opts)
  }
}
